let body = document.querySelector('body'),
    scrollPosition,
    siteHeader = document.querySelector('.site-header'),
    siteHeaderHeight,
    menuTrigger = document.querySelector('.header-main-menu-trigger'),
    headerMenuItems = document.querySelectorAll('.site-header .main-menu a'),
    expandTriggers = document.querySelectorAll('.expand-trigger'),
    newsMore = document.querySelectorAll('.type-aktuelles .wp-block-post-excerpt__more-link'),
    newsBack = document.querySelector('a[data-id="back-to-news"]');
let headerMenuTriggers = [...headerMenuItems, menuTrigger];

function menuController() {
  if (!body.classList.contains('header-menu-active')) {
    body.classList.add('header-menu-active')
  } else {
    body.classList.remove('header-menu-active')
  }
}

function scrollHeader() {
  scrollPosition = window.scrollY;
  siteHeaderHeight = siteHeader.offsetHeight;
  if (scrollPosition > siteHeaderHeight) 
  {
    siteHeader.classList.add('site-header-scroller');
  }
  else {
    siteHeader.classList.remove('site-header-scroller');
  }
  if (scrollPosition > 8) 
  {
    siteHeader.classList.add('site-header-shadow');
  }
  else {
    siteHeader.classList.remove('site-header-shadow');
  }
}

let getNextSibling = function (elem, selector) {

	// Get the next sibling element
	let sibling = elem.nextElementSibling;

	// If there's no selector, return the first sibling
	if (!selector) return sibling;

	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while (sibling) {
		if (sibling.matches(selector)) return sibling;
		sibling = sibling.nextElementSibling
	}
};

headerMenuTriggers.forEach(trigger => {
  trigger.addEventListener('click', menuController)
})
expandTriggers.forEach(trigger => {
  trigger.addEventListener('click', function(e) {
    this.classList.toggle('active');
    let trigger_id = this.getAttribute('id');
    if (trigger_id) {
      let target_id = '#expand' + trigger_id.substring(7);
      console.log(target_id);
      let target = document.querySelector(target_id);
      if (target.style.maxHeight){
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + "px";
      } 
    }
    else {
      let nextExpandContent = getNextSibling(this, '.expand-content');
      if (nextExpandContent.style.maxHeight){
        nextExpandContent.style.maxHeight = null;
      } else {
        nextExpandContent.style.maxHeight = nextExpandContent.scrollHeight + "px";
      } 
    }

   
    // console.log(id_array)
  })
})

scrollHeader();
window.addEventListener('scroll', function(event) {
  scrollHeader();
});

if (newsMore) {
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  let paged = urlParams.get('query-0-page');
  if (paged) {
    newsMore.forEach(function(e) {
      console.log(e)
      e.href = e.href + '?query-0-page=' + paged;
    });
  }

}

if (newsBack) {
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  let paged = urlParams.get('query-0-page');
  if (paged) {
    newsBack.href = newsBack.href + '?query-0-page=' + paged;
  }
}